import { z } from 'zod'

export const newsletterCreateSchema = z.object({
  client_id: z.string().min(1, 'Client ID is required'),
  subject: z.string().min(1, 'Subject is required'),
  html_content: z.string().min(1, 'HTML content is required'),
  original_filename: z.string().optional(),
  original_format: z.string().optional(),
  scheduled_date: z.string().datetime().optional(),
  subscriber_list_id: z.string().optional(),
})

export const newsletterUpdateSchema = z.object({
  subject: z.string().min(1).optional(),
  html_content: z.string().optional(),
  scheduled_date: z.string().datetime().optional(),
  subscriber_list_id: z.string().optional(),
})

export const subscriberListCreateSchema = z.object({
  name: z.string().min(1, 'List name is required'),
  r2_path: z.string().min(1, 'R2 path is required'),
  email_count: z.number().int().min(0),
  is_primary: z.number().int().min(0).max(1).optional(),
})
